import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from '@app/helpers/currency-format.helper';

@Pipe({
  name: 'currencyFormat',
  standalone: true,
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: number | null | undefined, currencyCode: string): string {
    return formatCurrency(value, currencyCode);
  }
}
